<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-form v-model="validForm">
      <v-card>
        <v-card-title>
          <span class="headline" v-text="item.id ? 'Update Customer' : 'Add Customer'"></span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md py-0>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field :rules="fNameRules" counter="50" v-model="item.title" label="Customer Name"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :rules="requireRule" v-model="item.customer_type" :items="customerTypes" item-text="title" item-value="id" label="Customer Type"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="mobileRules" mask="#### ### ###" counter="10" v-model="item.mobile" label="Mobile"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field :rules="emailRules" counter="50" v-model="item.email" label="Email"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="gstRules" counter="15" maxlength="15" v-model="item.gst_number" label="GST Number"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="requireRule" counter="8" type="number" v-model="item.credit_limit" label="Credit Limit"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field :rules="requireRule" counter="100" v-model="item.address1" label="Address 1"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field counter="100" v-model="item.address2" label="Address 2"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :rules="requireRule" v-model="item.country" :items="countries" item-text="country" item-value="id" label="Country"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :rules="requireRule" v-model="item.state" :items="states" item-text="state" item-value="id" label="State"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :rules="requireRule" v-model="item.district" :items="districts" item-text="district" item-value="id" label="District"></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm6>
                <v-autocomplete :rules="requireRule" v-model="item.panchayath" :items="panchayaths" item-text="panchayath" item-value="id" label="Panchayath"></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
          <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="upsertItem">{{item.id ? 'Update' : 'Save'}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>

  export default {
    name: 'CustomerCreate',
    props: {
      editingItem: null,
      active: false
    },

    data () {
      return {
        dialog: false,
        validForm: false,
        processing: false,
        showPasswords: false,
        customerTypes: [],
        states: [],
        districts: [],
        panchayaths: [],
        item: {},
        defaultItem: {
          id: null,
          title: "",
          panchayath: "",
          district: "",
          state: "",
          country: this.getDefault('country'),
          code: "",
          customer_type: "",
          gst_number: "",
          mobile: "",
          email: "",
          is_active: false,
          is_deleted: false,
          address1: "",
          address2: "",
          credit_limit: ""
        },
        fNameRules: [
            v => !!v || 'Name is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        emailRules: [
            value => {
              if (!value) return true

              return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) || 'E-mail must be valid'
            }
        ],
        passwordRules: [
            v => !!v || 'Password is required',
            v => v && v.length >= 5 || 'Must be more than 4 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        mobileRules: [
            v => !!v || 'Mobile Number is required',
            v => v && v.length >= 10 || 'Must be 10 characters',
            v => v && v.length <= 10 || 'Maximum 10 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        codeRules: [
            v => !!v || 'Customer No. is required',
            v => v && v.length >= 4 || 'Must be more than 3 characters',
            v => v && v.length <= 20 || 'Maximum 20 characters allowed'
        ],
        gstRules: [
          function(v) {
            if (!v || !v.length) {
              return true
            }
            else{
              return /^(([0-9]{2})([A-Z0-9]{10})([A-Z0-9]{1})Z([0-9]{1}))$/.test(v) || 'GST number must be valid'
            }
          }
        ]
      }
    },

    created () {
        
    },

    methods: {

      getCustomerTypes () {
        this.getAllData(this.config.apis.getCustomerTypes)
          .then( response => {
            this.customerTypes = response
          })
      },

      getDistricts (state) {
        this.processing = true
        this.districts = []
        this.axios.get(this.config.apis.getDistrictsByState.replace(":state", state))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.districts = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },

      getPanchayaths (district) {
        this.processing = true
        this.panchayaths = []
        this.axios.get(this.config.apis.getPanchayathsByDistrict.replace(":district", district))
        .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
              this.panchayaths = response.data.data
            }
        })
        .catch((error) => {
            this.processing = false
        })
      },

      upsertItem () {

        let is_update = !!this.item.id,
            api_path = this.config.apis.addCustomer + (is_update ? `/${this.item.id}` : ""),
            method = is_update ? "put" : "post"

        this.processing = true

        this.axios[method](api_path, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let item = this.extend({}, this.item)
              item.id = response.data.data.id

              let country = this.countries.filter( v => v.id == item.country )

              item.country_name = country ? country[0].country : ""

              let state = this.states.filter( v => v.id == item.state )

              item.state_name = state ? state[0].state : ""

              let district = this.districts.filter( v => v.id == item.district )

              item.district_name = district ? district[0].district : ""

              let panchayath = this.panchayaths.filter( v => v.id == item.panchayath )

              item.panchayath_name = panchayath ? panchayath[0].panchayath : ""

              this.notifySuccess(is_update ? 'updateSuccess' : 'insertSuccess')
              this.close()

              this.$emit('success', item)
            }
            else{
              this.notifyError(is_update ? 'updateError' : 'insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      close () {
        this.dialog = false
        this.$emit('update:active', this.dialog)
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
          this.$emit('update:editingItem', null)
        }, 300)
      }

    },

    mounted () {
      this.getCountries()
      this.getCustomerTypes()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    },

    components: {
      
    },

    watch: {

      'item.country': function(val, oldVal){
          if (val && val != oldVal) {
              this.getStatesByCountry(val).then( states => {
                this.states = states
              })
          }
      },

      'item.state': function(val, oldVal){
          if (val && val != oldVal) {
              this.getDistricts(val)
          }
      },

      'item.district': function(val, oldVal){
          if (val && val != oldVal) {
              this.getPanchayaths(val)
          }
      },

      editingItem (val, oldVal) {
        if (val && val !== oldVal && typeof val === 'object') {
          this.item = this.extend({}, val)
        }
      },

      active (val, oldVal) {
        this.dialog = val
      },

      dialog (val, oldVal) {
        if (val === false) {
          this.close()
        }
      }

    }

  }

</script>
